import { createContext, useContext } from "react";
import type { ChatChannelCategory } from "Components/Chat/chatChannelCategories";

type ChatCategoryContextType = {
  setSelectedCategory: (category: ChatChannelCategory) => void;
};

const ChatCategoryContext = createContext<ChatCategoryContextType | null>(null);

export const ChatCategoryProvider = ChatCategoryContext.Provider;

export const useChatCategory = () => {
  const context = useContext(ChatCategoryContext);
  if (!context) {
    throw new Error("useChatCategory must be used within ChatCategoryProvider");
  }
  return context;
};
